import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import Helper from "../../helper";
import Appconfig from "../../config/config";
import "./CasinoImageGrid.css";

const casinoGames = [
  {
    id: 1,
    name: "GOAL 2",
    image: "goal2.webp",
    providerCode: "SPB",
    gameCode: "goal",
  },
  {
    id: 2,
    name: "MATKA",
    image: "worli3.gif",
    providerCode: "DC",
    gameCode: "150615",
  },
  {
    id: 3,
    name: "V VIP TEENPATTI 1-DAY",
    image: "teen62.gif",
    providerCode: "EZ",
    gameCode: "227103",
  },
  {
    id: 4,
    name: "DOLIDANA",
    image: "dolidana.gif",
    providerCode: "DC",
    gameCode: "150603",
  },
  {
    id: 5,
    name: "MOGAMBO",
    image: "mogambo.gif",
    providerCode: "DC",
    gameCode: "600302",
  },
  {
    id: 6,
    name: "20-20 TEENPATTI VIP1",
    image: "teen20v1.webp",
    providerCode: "DC",
    gameCode: "150033",
  },
  {
    id: 7,
    name: "LUCKY 6",
    image: "lucky5.webp",
    providerCode: "DC",
    gameCode: "150605",
  },
  {
    id: 8,
    name: "BEACH ROULETTE",
    image: "roulette12.webp",
    providerCode: "EZ",
    gameCode: "221000",
  },
  {
    id: 9,
    name: "ROULETTE",
    image: "roulette13.webp",
    providerCode: "EZ",
    gameCode: "601000",
  },
  {
    id: 10,
    name: "GOLDEN ROULETTE",
    image: "roulette11.webp",
    providerCode: "DC",
    gameCode: "150604",
  },
  {
    id: 11,
    name: "TEENPATTI POISON ONE DAY",
    image: "poison.webp",
    providerCode: "DC",
    gameCode: "150669",
  },
  {
    id: 12,
    name: "UNIQUE TEENPATTI",
    image: "teenunique.webp",
    providerCode: "DC",
    gameCode: "150076",
  },
  {
    id: 13,
    name: "TEENPATTI POISON 20-20",
    image: "poison20.webp",
    providerCode: "DC",
    gameCode: "150075",
  },
  {
    id: 14,
    name: "UNLIMITED JOKER 20-20",
    image: "joker20.webp",
    providerCode: "DC",
    gameCode: "150071",
  },
  {
    id: 15,
    name: "TEENPATTI JOKER 20-20",
    image: "joker120.webp",
    providerCode: "DC",
    gameCode: "150661",
  },
  {
    id: 16,
    name: "UNLIMITED JOKER ONEDAY",
    image: "joker1.webp",
    providerCode: "DC",
    gameCode: "150072",
  },
  {
    id: 17,
    name: "20-20 TEENPATTI",
    image: "teen20.webp",
    providerCode: "DC",
    gameCode: "150033",
  },
  {
    id: 18,
    name: "BOLLYWOOD CASINO 2",
    image: "lottcard.webp",
    providerCode: "DC",
    gameCode: "150031",
  },
  {
    id: 19,
    name: "UNIQUE ROULETTE",
    image: "ourroullete.webp",
    providerCode: "EZ",
    gameCode: "5001",
  },
  {
    id: 20,
    name: "MINI SUPEROVER",
    image: "superover.webp",
    providerCode: "DC",
    gameCode: "150654",
  },
  {
    id: 21,
    name: "GOAL",
    image: "goal.webp",
    providerCode: "SPB",
    gameCode: "goal",
  },
  {
    id: 22,
    name: "ANDAR BAHAR",
    image: "abj.webp",
    providerCode: "DC",
    gameCode: "150656",
  },
  {
    id: 23,
    name: "LUCKY 15",
    image: "lucky15.webp",
    providerCode: "DC",
    gameCode: "151081",
  },
  {
    id: 24,
    name: "SUPER OVER 2",
    image: "superover2.webp",
    providerCode: "DC",
    gameCode: "150626",
  },
  {
    id: 25,
    name: "QUEEN TOP OPEN TEENPATTI",
    image: "teen41.webp",
    providerCode: "DC",
    gameCode: "150016",
  },
  {
    id: 26,
    name: "JACK TOP OPEN TEENPATTI",
    image: "teen42.webp",
    providerCode: "DC",
    gameCode: "150075",
  },
  {
    id: 27,
    name: "SIC BO2",
    image: "sicbo2.webp",
    providerCode: "DC",
    gameCode: "150670",
  },
  {
    id: 28,
    name: "INSTANT TEENPATTI 3.0",
    image: "teen33.webp",
    providerCode: "DC",
    gameCode: "150634",
  },
  {
    id: 29,
    name: "SIC BO",
    image: "sicbo.webp",
    providerCode: "DC",
    gameCode: "150602",
  },
  {
    id: 30,
    name: "BALL BY BALL",
    image: "ballbyball.webp",
    providerCode: "DC",
    gameCode: "151083",
  },
  {
    id: 31,
    name: "INSTANT TEENPATTI 2.0",
    image: "teen32.webp",
    providerCode: "DC",
    gameCode: "150655",
  },
  {
    id: 32,
    name: "TEENPATTI 1-DAY",
    image: "teen.webp",
    providerCode: "DC",
    gameCode: "150607",
  },
  {
    id: 33,
    name: "20-20 TEENPATTI",
    image: "teen20.webp",
    providerCode: "DC",
    gameCode: "150625",
  },
  {
    id: 34,
    name: "TEENPATTI OPEN",
    image: "teen9.webp",
    providerCode: "DC",
    gameCode: "150617",
  },
  {
    id: 35,
    name: "OPEN TEENPATTI",
    image: "teen8.webp",
    providerCode: "DC",
    gameCode: "150049",
  },
  {
    id: 36,
    name: "POKER 1-DAY",
    image: "poker.webp",
    providerCode: "DC",
    gameCode: "150032",
  },
  {
    id: 37,
    name: "20-20 POKER",
    image: "poker20.webp",
    providerCode: "DC",
    gameCode: "150005",
  },
  {
    id: 38,
    name: "POKER 6 PLAYERS",
    image: "poker6.webp",
    providerCode: "DC",
    gameCode: "150041",
  },
  {
    id: 39,
    name: "BACCARAT",
    image: "baccarat.webp",
    providerCode: "DC",
    gameCode: "150601",
  },
  {
    id: 40,
    name: "BACCARAT 2",
    image: "baccarat2.webp",
    providerCode: "DC",
    gameCode: "150002",
  },
  {
    id: 41,
    name: "20-20 DRAGON TIGER",
    image: "dt20.webp",
    providerCode: "DC",
    gameCode: "150600",
  },
  {
    id: 42,
    name: "1 DAY DRAGON TIGER",
    image: "dt6.webp",
    providerCode: "DC",
    gameCode: "150628",
  },
  {
    id: 43,
    name: "20-20 D T L",
    image: "dtl20.webp",
    providerCode: "DC",
    gameCode: "15007",
  },
  {
    id: 44,
    name: "20-20 DRAGON TIGER 2",
    image: "dt202.webp",
    providerCode: "EZ",
    gameCode: "150",
  },
  {
    id: 45,
    name: "32 CARDS A",
    image: "card32.webp",
    providerCode: "DC",
    gameCode: "151012",
  },
  {
    id: 46,
    name: "32 CARDS B",
    image: "card32eu.webp",
    providerCode: "DC",
    gameCode: "150608",
  },
  {
    id: 47,
    name: "ANDAR BAHAR",
    image: "ab20.webp",
    providerCode: "DC",
    gameCode: "150606",
  },
  {
    id: 48,
    name: "ANDAR BAHAR 2",
    image: "abj.webp",
    providerCode: "DC",
    gameCode: "150007",
  },
  {
    id: 49,
    name: "LUCKY 7 - A",
    image: "lucky7.webp",
    providerCode: "DC",
    gameCode: "151003",
  },
  {
    id: 50,
    name: "LUCKY 7 - B",
    image: "lucky7eu.webp",
    providerCode: "DC",
    gameCode: "150605",
  },
  {
    id: 51,
    name: "3 CARDS JUDGEMENT",
    image: "3cardj.webp",
    providerCode: "DC",
    gameCode: "150611",
  },
  {
    id: 52,
    name: "CASINO WAR",
    image: "war.webp",
    providerCode: "DC",
    gameCode: "150614",
  },
  {
    id: 53,
    name: "WORLI MATKA",
    image: "worli.webp",
    providerCode: "DC",
    gameCode: "150615",
  },
  {
    id: 54,
    name: "INSTANT WORLI",
    image: "worli2.webp",
    providerCode: "DC",
    gameCode: "151189",
  },
  {
    id: 55,
    name: "AMAR AKBAR ANTHONY",
    image: "aaa.webp",
    providerCode: "DC",
    gameCode: "150610",
  },
  {
    id: 56,
    name: "BOLLYWOOD CASINO",
    image: "btable.webp",
    providerCode: "DC",
    gameCode: "150623",
  },
  {
    id: 57,
    name: "LOTTERY",
    image: "lottcard.webp",
    providerCode: "DC",
    gameCode: "150020",
  },
  {
    id: 58,
    name: "5FIVE CRICKET",
    image: "cricketv3.webp",
    providerCode: "DC",
    gameCode: "150035",
  },
  {
    id: 59,
    name: "CRICKET MATCH 20-20",
    image: "cmatch20.webp",
    providerCode: "DC",
    gameCode: "150046",
  },
  {
    id: 60,
    name: "CASINO METER",
    image: "cmeter.webp",
    providerCode: "DC",
    gameCode: "151010",
  },
  {
    id: 61,
    name: "TEENPATTI - 2.0",
    image: "teen6.webp",
    providerCode: "DC",
    gameCode: "150066",
  },
  {
    id: 62,
    name: "QUEEN",
    image: "queen.webp",
    providerCode: "DC",
    gameCode: "151016",
  },
  {
    id: 63,
    name: "RACE20",
    image: "race20.webp",
    providerCode: "DC",
    gameCode: "150613",
  },
  {
    id: 64,
    name: "LUCKY 7 - C",
    image: "lucky7eu2.webp",
    providerCode: "DC",
    gameCode: "150006",
  },
  {
    id: 65,
    name: "SUPER OVER",
    image: "superover.webp",
    providerCode: "DC",
    gameCode: "150034",
  },
  {
    id: 66,
    name: "THE TRAP",
    image: "trap.webp",
    providerCode: "DC",
    gameCode: "901037",
  },
  {
    id: 67,
    name: "2 CARDS TEEPATTI",
    image: "patti2.webp",
    providerCode: "DC",
    gameCode: "150042",
  },
  {
    id: 68,
    name: "29CARD BACCARAT",
    image: "teensin.webp",
    providerCode: "DC",
    gameCode: "151012",
  },
  {
    id: 69,
    name: "MUFLIS TEENPATTI",
    image: "teenmuf.webp",
    providerCode: "DC",
    gameCode: "150647",
  },
  {
    id: 70,
    name: "RACE TO 17",
    image: "race17.webp",
    providerCode: "DC",
    gameCode: "150047",
  },
  {
    id: 71,
    name: "20-20 TEENPATTI B",
    image: "teen20b.webp",
    providerCode: "DC",
    gameCode: "151011",
  },
  {
    id: 72,
    name: "TRIO",
    image: "trio.webp",
    providerCode: "DC",
    gameCode: "150619",
  },
  {
    id: 73,
    name: "NOTE NUMBER",
    image: "notenum.webp",
    providerCode: "DC",
    gameCode: "150636",
  },
  {
    id: 74,
    name: "1 CARD 20-20",
    image: "teen120.webp",
    providerCode: "DC",
    gameCode: "150038",
  },
  {
    id: 75,
    name: "1 CARD ONE-DAY",
    image: "teen1.webp",
    providerCode: "DC",
    gameCode: "150040",
  },
  {
    id: 76,
    name: "ANDAR BAHAR 50 CARDS",
    image: "ab3.webp",
    providerCode: "DC",
    gameCode: "150057",
  },
  {
    id: 77,
    name: "AMAR AKBAR ANTHONY 2",
    image: "aaa2.webp",
    providerCode: "DC",
    gameCode: "150080",
  },
  {
    id: 78,
    name: "RACE TO 2ND",
    image: "race2.webp",
    providerCode: "DC",
    gameCode: "150635",
  },
  {
    id: 79,
    name: "INSTANT TEENPATTI",
    image: "teen3.webp",
    providerCode: "DC",
    gameCode: "150655",
  },
  {
    id: 80,
    name: "DUS KA DUM",
    image: "dum10.webp",
    providerCode: "DC",
    gameCode: "150037",
  },
  {
    id: 81,
    name: "1 CARD METER",
    image: "cmeter1.webp",
    providerCode: "DC",
    gameCode: "150630",
  },
];

const CasinoImageGrid = () => {
  const navigate = useNavigate();
  const userInfo = Helper();

  const openGame = (game) =>
    CreateAndLaunchWCOCasino(
      game.providerCode,
      game.gameCode,
      game.type
    );

  const CreateAndLaunchWCOCasino = async (
    providerCode,
    gameCode,
    type = null
  ) => {
    if (!userInfo?._id) {
      toast.error("Please login to play this game.", {
        autoClose: 2000,
      });

      navigate("/login");
      return false;
    }

    if (!providerCode || !gameCode) {
      console.error("Casino configuration is missing:", {
        providerCode,
        gameCode,
        type,
      });

      toast.error("Game configuration is missing.", {
        autoClose: 2000,
      });

      return false;
    }

    const userData = {
      user_id: userInfo._id,
      user_name: userInfo.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: providerCode,
      game_code: gameCode,
      type: type ?? null,
    };



    try {

      console.log("Casino launch payload:", userData);
      console.log(
        "Casino launch endpoint:",
        `${Appconfig.casinoUrl}wco/login`
      );

      const response = await axios({
        method: "post",
        url: `${Appconfig.casinoUrl}wco/login`,
        headers: {
          "Content-Type": "application/json",
        },
        data: userData,
      });

      const status = response?.data?.status?.code;
      const launchURL = response?.data?.launchURL;

      if (status === "SUCCESS" && launchURL) {
        window.location.assign(launchURL);
        return true;
      }

      if (
        status === "VALIDATION_ERROR" ||
        status === "UNKNOWN_ERROR"
      ) {
        toast.error("Game Not Found.", {
          autoClose: 2000,
        });

        return false;
      }

      if (status === "AUTHENTICATION_FAILED") {
        toast.error(
          response?.data?.status?.message ||
          "Casino authentication failed.",
          {
            autoClose: 2000,
          }
        );

        return false;
      }

      toast.error(
        response?.data?.status?.message ||
        "Unable to launch this game.",
        {
          autoClose: 2000,
        }
      );

      return false;
    } catch (error) {
      console.error("Casino launch error:", error);

      toast.error(
        error?.response?.data?.status?.message ||
        "Unable to launch casino game.",
        {
          autoClose: 2000,
        }
      );

      return false;
    }
  };

  return (
    <section
      className="casino-image-section"
      aria-label="Casino games"
    >
      <div className="casino-image-grid">
        {casinoGames.map((game) => (
          <button
            key={game.id}
            type="button"
            className="casino-image-card"
            onClick={() => openGame(game)}
            title={game.name}
          >
            <span className="casino-card-image">
              <img
                src={`${process.env.PUBLIC_URL}/Images/casino-games/${game.image}`}
                alt={game.name}
                loading="lazy"
                draggable="false"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src =
                    `${process.env.PUBLIC_URL}/Images/casino-games/default.webp`;
                }}
              />
            </span>

            <span className="casino-card-title">
              {game.name}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default CasinoImageGrid;